import { connect } from 'react-redux';
import config from 'config';
import { sendFeedback, showFeedbackForm, resetFeedbackForm } from '../actions/feedbackForm';
import FeedbackForm from '../components/FeedbackForm';

const mapStateToProps = (state, props) => {
    const { googleRecaptchaSiteKey:reCaptchaKey = ""} = config;
    const { common: { display: { feedbackForm: { sent: feedbackSent = false, sendingError = false } = {}} = {}} = {}} = state;
    return {...props, reCaptchaKey, feedbackSent, sendingError}
}

const mapDispatchToProps = dispatch => {
    return {
        formSubmitAction: data => dispatch(sendFeedback(data)),
        closeAction: () => dispatch(showFeedbackForm(false)),
        resetFormAction: () => dispatch(resetFeedbackForm())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm);


// WEBPACK FOOTER //
// ./modules/Common/containers/FeedbackForm.js